import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { Report, VerifiedUser } from '@material-ui/icons'
import { red, green } from '@material-ui/core/colors'

const styles = (theme) => ({
  responseBox: {
    display: 'flex',
  },
  iconGood: {
    fontSize: 48,
    color: green[500],
  },
  iconBad: {
    fontSize: 48,
    color: red[800],
  },
  centerList: {
    margin: 'auto',
    padding: '10px',
  },
  spinner: {
    color: theme.palette.primary.main,
  },
})

export class HomepageResponse extends Component {
  static defaultProps = {}

  render() {
    // Create variables from values of matching keys
    const { classes } = this.props
    let toRender = <br />

    if (
      this.props.fetchingState === false &&
      this.props.responseData == null &&
      this.props.responseErrorData == null
    ) {
      toRender = <br />
    } else if (this.props.fetchingState === true) {
      toRender = (
        <div>
          <CircularProgress className={classes.spinner} thickness={7} />
          <h3>Submitting, Please Wait...</h3>
        </div>
      )
    } else if (this.props.responseData != null) {
      if (this.props.responseData['status'] === 201) {
        toRender = (
          <div className={classes.responseBox}>
            <List className={classes.centerList}>
              <ListItem>
                <ListItemIcon>
                  <VerifiedUser className={classes.iconGood} />
                </ListItemIcon>
                <ListItemText
                  primary="Notification successfully submitted!"
                  secondary="Your outgoing messages will be sent as scheduled"
                />
              </ListItem>
            </List>
            <br />
            <br />
          </div>
        )
      } else {
        toRender = (
          <div className={classes.responseBox}>
            <List className={classes.centerList}>
              <ListItem divider>
                <ListItemIcon>
                  <Report className={classes.iconBad} />
                </ListItemIcon>
                <ListItemText primary="Notification failed to submit!" />
              </ListItem>
              <ListItem divider={false}>
                <ListItemText primary="Error Code" secondary="500" />
              </ListItem>
            </List>
            <br />
            <br />
          </div>
        )
      }
    } else if (this.props.responseErrorData != null) {
      toRender = (
        <div className={classes.responseBox}>
          <List className={classes.centerList}>
            <ListItem divider>
              <ListItemIcon>
                <Report className={classes.iconBad} />
              </ListItemIcon>
              <ListItemText primary="Notification failed to submit!" />
            </ListItem>
            <ListItem divider={false}>
              <ListItemText
                primary="Error Code"
                secondary={this.props.responseErrorData}
              />
            </ListItem>
          </List>
          <br />
          <br />
        </div>
      )
    }

    return <div>{toRender}</div>
  }
}

HomepageResponse.propTypes = {}

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

const mapStateToProps = (state) => ({
  responseData: state.homepageCreate.data,
  responseErrorData: state.homepageCreate.errorData,
  fetchingState: state.homepageCreate.fetching2,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(HomepageResponse))
